import { render } from "./header-language-switcher.vue?vue&type=template&id=7842390c&scoped=true&ts=true"
import script from "./header-language-switcher.vue?vue&type=script&lang=ts"
export * from "./header-language-switcher.vue?vue&type=script&lang=ts"

import "./header-language-switcher.vue?vue&type=style&index=0&id=7842390c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7842390c"]])

export default __exports__